<template>
  <div class="department-management">
    <!-- 新增部门按钮 -->
    <el-button type="primary" @click="dialogVisible = true">新增部门</el-button>

    <!-- 部门列表 -->
    <ul>
      <li v-for="(dept, index) in departments" :key="index">
        {{ dept.name }} 
        <el-button size="mini" @click="deleteDept(dept._id)">删除</el-button>
      </li>
    </ul>

    <!-- 新增部门对话框 -->
    <el-dialog title="新增部门" :visible.sync="dialogVisible" width="30%">
      <el-form :model="newDeptForm">
        <el-form-item label="部门名称">
          <el-input v-model="newDeptForm.name"></el-input>
        </el-form-item>
        <!-- 移除了上级部门的选择 -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addDept">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      dialogVisible: false,
      newDeptForm: {
        name: ''
      },
      departments: []
    };
  },
  created() {
    this.fetchDepartments();
  },
  methods: {
    addDept() {
      this.$http.post('/departments', this.newDeptForm)
        .then(response => {
          this.departments.push(response); // 注意这里应该是response.data而不是response
          this.dialogVisible = false;
          this.$message({
            type: 'success',
            message: '部门添加成功!'
          });
          // 清空表单
          this.newDeptForm.name = '';
        })
        .catch(error => {
          console.error("新增部门失败:", error);
          this.$message.error('新增部门失败，请重试');
        });
    },
    fetchDepartments() {
      this.$http.get('/departments')
        .then(response => {
          this.departments = response; // 注意这里应该是response.data而不是response
        })
        .catch(error => {
          console.error("获取部门列表失败:", error);
        });
    },
    deleteDept(id) {
      this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/departments/${id}`)
          .then(() => {
            this.departments = this.departments.filter(dept => dept._id !== id);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(error => {
            console.error("删除部门失败:", error);
            this.$message.error('删除部门失败，请重试');
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    }
  }
};
</script>

<style scoped>
.department-management ul {
  list-style-type: none;
  padding: 0;
}
.department-management li {
  margin-bottom: 10px;
}
</style>